import { h } from 'preact';
import React, { useEffect, useRef, useState } from 'react';
import domPurify from 'dompurify';

import { Sanitize } from '../Sanitize/Sanitize';
import { TextSettings } from './TextSettings';
import { languageUsed, makeText } from '../../util';
import { useDev } from '../../hooks';

import TextOttWrapper from './TextOttWrapper';

import './Text.css';

export const Text = ({
  component,
  language,
  className,
  dev,
  path,
  makeChoice,
}) => {
  const { devActions, devClass, pathString } = useDev(path, dev);
  const nv = useRef(null);

  useEffect(() => {
    if (nv.current) {
      const aTags = nv.current.getElementsByTagName('A');
      for (let i = 0; i < aTags.length; i++) {
        aTags[i].addEventListener('click', handleLinkClick)
      }
    };

    return () => {
      if (nv.current) {
        const aTags = nv.current.getElementsByTagName('A');
        for (let i = 0; i < aTags.length; i++) {
          aTags[i].removeEventListener('click', handleLinkClick)
        }
      };
    };
  }, []);

  function handleLinkClick(e) {
    if (this.href && this.href.indexOf('$$$$:') >= 0) {
      e.preventDefault();

      const choiceOptions = component.settings.choice_options || [];
      const optionId = this.href.split('$$$$:')[1];

      const option = choiceOptions.find(o => o.data.button_text === optionId);
      if (option && option.usePmV2Opt) {
        makeChoice(option.type, languageUsed(language, settings, 'text'));
      } else if (option && option.data.button_text) {
        makeChoice(option.data.button_text, languageUsed(language, settings, 'text'));
      };
    };
  };

  const settings = new TextSettings(component.settings);
  const styles = {
    ...settings.padding,
    ...settings.margin,
    ...settings.border,
    ...settings.font,
  };

  styles.textAlign = settings.align;
  /* WIDTH & HEIGHT */
  const { paddingLeft, paddingRight } = settings.padding;
  const { marginLeft, marginRight } = settings.margin;
  styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
  styles.height = settings.height.type === 'auto' ? 'auto' : settings.height.value + settings.height.type;
  if (settings.width.type === '%') {
    const adjustment = paddingLeft + paddingRight + marginLeft + marginRight;
    styles.width = `calc(${settings.width.value}% - ${isNaN(adjustment) ? 0 : adjustment}px`;
  };

  /* MANAGE LINK STYLING */
  const linkClassName = `text-link-${path.join('-')}`;
  const linkStyleTagContents = domPurify.sanitize(`
    .${linkClassName}:hover { color:${settings.hover.color} !important; text-decoration:${settings.hover.textDecoration} !important; font-weight: ${settings.hover.fontWeight} !important;  }
  `);
  const linkStyleTag = `<style>${linkStyleTagContents}</style>`
  const linkStyle = `color:${settings.link.color};text-decoration:${settings.link.textDecoration};font-weight: ${settings.link.fontWeight};`;
  const textHTML = makeText(dev, settings, 'text', language)
    .replace(/<a ([^>]*(href)[^>]*)>/g, function (match, attributes, hrefMatch) { return `<a tabindex="0" class='${linkClassName}' style='${linkStyle}' ${attributes}>`; });

  return (
    <TextOttWrapper pRef={nv}>
      <p
        className={'message-component text no-children' + className + devClass}
        style={styles}
        tabIndex={settings.startFocus ? 1 : 0}
        path={pathString}
        ref={element => {
          nv.current = element;
          if (element) {
            if (settings.font.size) {
              element.style.setProperty('font-size', Settings.font.size + 'px', 'important');
            }
          }
        }}
        {...devActions}
        dangerouslySetInnerHTML={{ __html: linkStyleTag + Sanitize({ html: textHTML }) }}
      />
    </TextOttWrapper >
  );
}
